/**
 * LogLevel
 *
 * Different severities of logs in order of severity
 */
export type LogLevel = 'debug' | 'info' | 'log' | 'warn' | 'error';

/** Numeric rank so min-level checks are by severity, not string order. */
export const LOG_LEVEL_RANK: Record<LogLevel, number> = {
    debug: 0,
    info: 1,
    log: 2,
    warn: 3,
    error: 4,
};

/**
 * Function signature of the logging function - mimics the console.log signature
 * Defined once here using any to avoid having to use eslint-disable rules everywhere
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type LogFn = (message?: any, ...optionalParams: any[]) => void;

/**
 * Driver
 *
 * Functions that a provider is required to implement to be used as a provider
 */
export interface DriverI {
    debug: LogFn;
    info: LogFn;
    log: LogFn;
    warn: LogFn;
    error: LogFn;
}
